import {filterOffers, serialProductPriceFilter} from '@/utils/filter-helpers'

export default function (products, filters) {
    // DEFINE FILTER FUNCTIONS
    const fn = {}
    fn.price = serialProductPriceFilter

    fn.name = function (product, values) {
        if (values) {
            return product.name.toLowerCase().includes(values.toLowerCase())
        }
        return true
    }

    fn.duration = function (product, values) {
        return values[0] <= product.duration && values[1] >= product.duration
    }

    fn.dates = function (product, values) {
        product.offers = product.offers.filter(offer => {
            return values.includes(offer.startDate)
        })

        return product.offers.length > 0
    }

    fn.availability = function (product, values) {
        if (!product.offers) return true

        product.offers = product.offers.filter(offer => {
            const key = offer.available ? 'available' : 'on_request'
            const index = values.indexOf(key)
            return index >= 0
        })

        return product.offers.length > 0
    }

    fn.cancellationPolicy = function (product, values) {
        product.offers = product.offers.filter(offer => {
            const index = values.indexOf(offer.cancellationLabel)
            return index >= 0
        })
        return product.offers.length > 0
    }

    fn.supplierName = function (product, values) {
        return values.includes(product.supplierName)
    }

    fn.mealTypeName = function (product, values) {
        if (!product.offers) return true

        product.offers = product.offers?.filter(offer => {
            return values.includes(offer.mealTypeName)
        })

        return product.offers.length > 0
    }

    fn.cabinType = function (product, values) {
        if (!product.offers) return true

        product.offers = product.offers?.filter(offer => {
            return values.includes(offer.serviceName)
        })

        return product.offers.length > 0
    }

    fn.cruiseLine = function (product, values) {
        return values.includes(product.cruiseLine)
    }

    fn.shipName = function (product, values) {
        return values.includes(product.shipName)
    }

    //START FILTER PROCESS
    return filterOffers(products, filters, fn)
}
